import React from "react"

import {
  BellIcon,
  BookOpenIcon,
  MegaphoneIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid"

import { Color } from "~tailwindui/types/enums"

import { path } from "~Tutor/TutorRoutes"
import ActionList from "~Tutor/components/ActionList"

export type TutoringOpportunitiesProps = {
  viewer: {
    id: string
    requestedSessions: {
      id: string
    }[]
    availableStudyGroupReplacements: {
      id: string
    }[]
    openGenerationInvites: {
      availableStudyGroups: {
        id: string
      }
    }[]
    registerableCourseClusters: {
      id: string
    }[]
  }
}

const TutoringOpportunities: React.FC<TutoringOpportunitiesProps> = ({
  viewer,
}) => {
  return (
    <ActionList
      title="Tutoring Opportunities"
      color={Color.Green}
      listItems={[
        {
          icon: BellIcon,
          path: path("requestedSessionsIndex"),
          text: `Requested Sessions (${viewer.requestedSessions.length})`,
          active: viewer.requestedSessions.length > 0,
        },
        {
          icon: UserGroupIcon,
          path: path("availableStudyGroupReplacementsIndex"),
          text: `Study Group Replacements (${viewer.availableStudyGroupReplacements.length})`,
          active: viewer.availableStudyGroupReplacements.length > 0,
        },
        {
          icon: BookOpenIcon,
          path: path("courseClustersIndex"),
          text: `View Registerable Course Groups (${viewer.registerableCourseClusters.length})`,
          active: viewer.registerableCourseClusters.length > 0,
        },
        {
          icon: MegaphoneIcon,
          path: path("openGenerationInvitesIndex"),
          text: `Open Study Group Invitations (${
            viewer.openGenerationInvites
              .map(invite => invite.availableStudyGroups)
              .flat().length
          })`,
          active: viewer.openGenerationInvites.length > 0,
        },
      ].sort((a, b) => Number(b.active) - Number(a.active))}
    />
  )
}

export default TutoringOpportunities
